import { IContentItem, IContentItemUserValidation, IContentItemEvent } from 'redhotpie-shared-lib/interfaces/ICommunity';
import { IActor } from 'redhotpie-shared-lib/interfaces/INewFeed';
import TYPE from '../constants/newFeed';
import * as utils from '../functions/utils';
import actor, { IActorData } from './actor';
import Group from './group';
import GroupDetail from './groupDetails';
import article from './homeArticle';
import clubReview from './homeClubReview';
import clubReviewList from './homeClubReviewList';
import homeDateFinder from './homeDatefinder';
import event, { EventData } from './homeEvent';
import forum from './homeForum';
import sexsecret from './homeSexSecret';
import story from './homeStory';
import testimonial from './homeTestimonial';
import homeTravelProfile from './homeTravleProfile';
import userValidation from './homeUserValidation';
import otgGallery from './otgGallery';
import otgPhoto from './otgPhoto';
import otgVideo from './otgVideo';
import uploadedPhoto from './uploadedPhoto';
import { IGroupContentItem } from '../interfaces/ICommunity';

interface ContentItem {
  [key: string]: any;
}

interface FeedObject {
  UserID: string;
  TypeID: string;
  DateCreated: number;
  DateEdited: string;
  Actor?: IActorData;
  ContentItem?: ContentItem;
  IsPinned?: boolean;
}

export default class Feed {
  userId: string | null;
  typeId: string;
  dateCreated?: number | string;
  dateEdited: string;
  contentItem?:
    | IContentItem
    | IContentItem[]
    | IContentItemUserValidation
    | IContentItemUserValidation[]
    | IContentItemEvent
    | IGroupContentItem;
  hasHeader?: boolean;
  icon?: string;
  typeName?: string;
  entityText?: string;
  actor: IActor;
  isHaveSafeMode: boolean;
  safeModeText: string | null;
  isPinned: boolean;

  constructor() {
    this.userId = null;
    this.typeId = '';
    this.dateCreated = '';
    this.dateEdited = '';
    this.contentItem = {};
    this.hasHeader = undefined;
    this.icon = undefined;
    this.typeName = undefined;
    this.entityText = undefined;
    this.actor = {};
    this.isHaveSafeMode = false;
    this.safeModeText = null;
    this.isPinned = false;
  }

  static generateIcon(typeID: string): string {
    if (TYPE.LIKE.hasOwnProperty(typeID) || typeID === TYPE.CommentLike) {
      return 'icNotificationLikes';
    }
    if (
      TYPE.COMMENT.hasOwnProperty(typeID) ||
      TYPE.COMMENT_REPLY.hasOwnProperty(typeID) ||
      TYPE.ADDED.hasOwnProperty(typeID) ||
      typeID === TYPE.ReplyLike ||
      typeID === TYPE.ClubPost ||
      typeID === TYPE.ClubAlbum
    ) {
      if (
        typeID === TYPE.ADDED.EventAdd ||
        TYPE.GLOBE.EroticStoriesAdd === typeID ||
        typeID === TYPE.ClubPost ||
        typeID === TYPE.ClubAlbum
      ) {
        return 'icUserGroup';
      }
      return 'icNotificationMessage';
    }
    if (TYPE.UPLOADED.hasOwnProperty(typeID) || typeID === TYPE.UserProfileUpdated) {
      return 'icNotificationPhotos';
    }
    if (typeID === TYPE.EventInterestAdd) {
      return 'icUserGroup';
    }
    return '';
  }

  static generateTypeName(typeID: string): string {
    if (typeID.includes(TYPE.OnTheGroundGallery) || typeID.includes('OntheGroundGallery')) {
      return TYPE.OTG_NAME.OTG_Gallery;
    }
    if (typeID.includes('PhotoUploaded')) {
      return TYPE.OTG_NAME.OTG_Photos;
    }
    if (
      typeID.includes(TYPE.OnTheGroundVideo) ||
      typeID === TYPE.YouTubeVideo ||
      typeID.includes('OntheGroundVideo') ||
      typeID.includes('VimeoVideo')
    ) {
      return TYPE.OTG_NAME.OTG_Video;
    }
    if (typeID.includes(TYPE.OntheGroundPhoto) || typeID.includes('OnTheGroundPhoto')) {
      return TYPE.OTG_NAME.OTG_Photo;
    }
    if (typeID.includes(TYPE.Article)) {
      return TYPE.OTG_NAME.OTG_Article;
    }
    if (typeID.includes(TYPE.Forum)) {
      return TYPE.OTG_NAME.OTG_Forum;
    }
    if (typeID.includes('Story') || typeID.includes('Stories')) {
      return TYPE.OTG_NAME.OTG_Story;
    }
    if (typeID.includes('Event')) {
      return TYPE.OTG_NAME.OTG_Event;
    }
    if (typeID === TYPE.UserProfileUpdated) {
      return TYPE.OTG_NAME.OTG_ProfileUpdate;
    }
    if (typeID.includes(TYPE.TravelProfile)) {
      return TYPE.OTG_NAME.OTG_Travel;
    }
    if (typeID.includes(TYPE.DateFinder)) {
      return TYPE.OTG_NAME.OTG_DateFinder;
    }
    if (typeID.includes(TYPE.Testimonial)) {
      return TYPE.OTG_NAME.OTG_Testimonial;
    }
    if (typeID.includes(TYPE.SexSecret)) {
      return TYPE.OTG_NAME.OTG_SexSecret;
    }
    if (typeID.includes(TYPE.UserValidation)) {
      return TYPE.OTG_NAME.OTG_Validation;
    }
    if (typeID === TYPE.ClubReviewList) {
      return TYPE.OTG_NAME.OTG_ClubReviewList;
    }
    if (typeID.includes(TYPE.ClubReview)) {
      return TYPE.OTG_NAME.OTG_Review;
    }
    if (typeID === TYPE.ClubPost) {
      return TYPE.OTG_NAME.OTG_GroupPost;
    }
    if (typeID === TYPE.ClubAlbum) {
      return TYPE.OTG_NAME.OTG_GroupAlbum;
    }
    if (typeID === TYPE.Club) {
      return TYPE.Club;
    }
    if (typeID === TYPE.ClubJoin) {
      return TYPE.ClubJoin;
    }
    return '';
  }

  static generateEntityText(typeID: string): string {
    if (typeID === TYPE.ClubReviewList) {
      return 'EntityClubReviewList';
    }
    if (TYPE.LIKE.hasOwnProperty(typeID)) {
      return 'EntityLike';
    }
    if (TYPE.ADDED.hasOwnProperty(typeID)) {
      if (typeID === TYPE.ADDED.EventAdd) {
        return 'EntityPosted';
      }
      return 'EntityAdd';
    }
    if (TYPE.COMMENT.hasOwnProperty(typeID)) {
      return 'EntityComment';
    }
    if (TYPE.COMMENT_REPLY.hasOwnProperty(typeID)) {
      return 'EntityCommentReply';
    }
    if (TYPE.UPLOADED.hasOwnProperty(typeID)) {
      return 'EntityUpLoaded';
    }
    if (typeID === TYPE.ReplyLike) {
      return 'EntityReplyLike';
    }
    if (typeID === TYPE.CommentLike) {
      return 'EntityCommentLike';
    }
    if (typeID === TYPE.UserProfileUpdated) {
      return 'EntityUpdatedProfile';
    }
    if (typeID === TYPE.UserValidation || typeID === TYPE.UserValidationList) {
      return 'EntityUserValidation';
    }
    if (typeID === TYPE.ClubReview) {
      return 'EntityClubReview';
    }
    if (typeID === TYPE.EventInterestAdd) {
      return 'EntityInterest';
    }
    if (typeID === TYPE.ClubPost) {
      return 'EntityGroupPost';
    }
    if (typeID === TYPE.ClubAlbum) {
      return 'EntityGroupAlbum';
    }
    if (typeID === TYPE.ClubJoin) {
      return 'EntityGroupJoin';
    }
    return '';
  }

  static mappingContentItem(typeID: string, contentItem: ContentItem): IContentItem | IContentItem[] | undefined {
    if (typeID.includes(TYPE.OnTheGroundGallery) || typeID.includes('OntheGroundGallery')) {
      return otgGallery.mappingObject(contentItem);
    }
    if (typeID.includes('PhotoUploaded')) {
      return uploadedPhoto.mappingObject(contentItem);
    }
    if (
      typeID.includes(TYPE.OnTheGroundVideo) ||
      typeID === TYPE.YouTubeVideo ||
      typeID.includes('OntheGroundVideo') ||
      typeID.includes('VimeoVideo')
    ) {
      return otgVideo.mappingObject(contentItem);
    }
    if (typeID.includes(TYPE.OntheGroundPhoto) || typeID.includes('OnTheGroundPhoto')) {
      return otgPhoto.mappingObject(contentItem);
    }
    if (typeID === TYPE.TravelProfile || typeID === TYPE.TravelProfileAddMatch) {
      return homeTravelProfile.mappingObject(contentItem);
    }
    if (typeID === TYPE.Testimonial || typeID === TYPE.CompetitionTestimonialAdd) {
      return testimonial.mappingObject(contentItem);
    }
    if (typeID.includes(TYPE.Article)) {
      return article.mappingObject(contentItem);
    }
    if (typeID.includes(TYPE.Forum)) {
      return forum.mappingObject(contentItem);
    }
    if (typeID.includes('Story') || typeID.includes('Stories')) {
      return story.mappingObject(contentItem);
    }
    if (typeID.includes('Event')) {
      return event.mappingObject(contentItem as EventData);
    }
    if (typeID.includes('DateFinder')) {
      return homeDateFinder.mappingObject(contentItem);
    }
    if (typeID.includes(TYPE.SexSecret)) {
      return sexsecret.mappingObject(contentItem);
    }
    if (typeID.includes(TYPE.UserValidation)) {
      if (typeID === TYPE.UserValidation) return userValidation.mappingObject(contentItem);
      return userValidation.mappingArray(contentItem?.ItemList);
    }
    if (typeID === TYPE.ClubReviewList) {
      return clubReviewList.mappingObject(contentItem);
    }
    if (typeID.includes(TYPE.ClubReview)) {
      return clubReview.mappingObject(contentItem);
    }
    if (typeID === TYPE.ClubPost || typeID === TYPE.ClubAlbum) {
      return GroupDetail.mappingGroupActivityContent(contentItem);
    }
    if (typeID === TYPE.Club) {
      return Group.mappingSuggestGroupActivity(contentItem);
    }
    if (typeID === TYPE.ClubJoin) {
      return Group.mappingSuggestGroupActivity(contentItem);
    }

    return undefined;
  }

  static checkSafeMode(typeID: string): boolean {
    return (
      typeID.includes(TYPE.OnTheGroundGallery) ||
      typeID.includes('OntheGroundGallery') ||
      typeID.includes(TYPE.Article) ||
      typeID.includes('Event') ||
      typeID.includes(TYPE.Forum) ||
      typeID.includes(TYPE.OntheGroundPhoto) ||
      typeID.includes('OnTheGroundPhoto') ||
      typeID.includes(TYPE.Forum) ||
      typeID.includes(TYPE.OnTheGroundVideo) ||
      typeID === TYPE.YouTubeVideo ||
      typeID.includes('OntheGroundVideo') ||
      typeID.includes('Story') ||
      typeID.includes('Stories') ||
      typeID.includes('PhotoUploaded') ||
      typeID.includes('VimeoVideo') ||
      typeID.includes('Club')
    );
  }

  static safeModeTextGenerate(typeID: string): string | null {
    if (
      typeID.includes(TYPE.OnTheGroundVideo) ||
      typeID.includes('VimeoVideo') ||
      typeID === TYPE.YouTubeVideo ||
      typeID.includes('OntheGroundVideo')
    ) {
      return 'video';
    }

    if (typeID.includes(TYPE.Article)) {
      return 'article';
    }
    if (
      typeID.includes(TYPE.OnTheGroundGallery) ||
      typeID.includes('OntheGroundGallery') ||
      typeID.includes('Event') ||
      typeID.includes(TYPE.Forum) ||
      typeID.includes(TYPE.OntheGroundPhoto) ||
      typeID.includes('OnTheGroundPhoto') ||
      typeID.includes(TYPE.Forum) ||
      typeID.includes('Story') ||
      typeID.includes('Stories') ||
      typeID.includes('PhotoUploaded')
    ) {
      return 'post';
    }
    return null;
  }

  static mappingObject(_obj: FeedObject): Feed {
    let obj = Object.assign(new Feed(), _obj);
    let typeName = '';
    let isHaveSafeMode = false;
    let safeModeText: string | null = null;
    if (_obj.TypeID) {
      if (_obj.TypeID === 'CommentLike' || _obj.TypeID === 'ReplyLike') {
        typeName = Feed.generateTypeName(_obj.ContentItem?.ParentType);
        isHaveSafeMode = Feed.checkSafeMode(_obj.ContentItem?.ParentType);
        safeModeText = Feed.safeModeTextGenerate(_obj.ContentItem?.ParentType);
      } else {
        typeName = Feed.generateTypeName(_obj.TypeID);
        isHaveSafeMode = Feed.checkSafeMode(_obj.TypeID);
        safeModeText = Feed.safeModeTextGenerate(_obj.TypeID);
      }
    }

    obj.userId = obj.UserID;
    obj.typeId = _obj.TypeID ? _obj.TypeID : '';
    obj.dateCreated = _obj.DateCreated ? _obj.DateCreated : '';
    obj.dateEdited = _obj.DateEdited || '';
    obj.hasHeader =
      (!!_obj.Actor &&
        !_obj.TypeID.includes('Testimonial') &&
        _obj.TypeID !== TYPE.DateFinderAdd &&
        _obj.TypeID !== TYPE.UserValidation &&
        _obj.TypeID !== TYPE.ClubReview) ||
      _obj.TypeID === TYPE.GLOBE.EroticStoriesAdd;
    let icon = 'icGlobe';
    if (_obj.TypeID !== TYPE.GLOBE.ForumActivity) {
      icon = _obj.TypeID ? Feed.generateIcon(_obj.TypeID) : '';
    }
    obj.icon = icon;
    obj.typeName = typeName;
    obj.entityText = _obj.TypeID ? Feed.generateEntityText(_obj.TypeID) : '';
    obj.actor = _obj.Actor ? actor.mappingObject(_obj.Actor) : {};
    if (_obj.TypeID && _obj.ContentItem) {
      if (_obj.TypeID === 'CommentLike' || _obj.TypeID === 'ReplyLike') {
        obj.contentItem = Feed.mappingContentItem(_obj.ContentItem.ParentType, _obj.ContentItem);
      } else {
        obj.contentItem = Feed.mappingContentItem(_obj.TypeID, _obj.ContentItem);
      }
    }
    obj.isHaveSafeMode = isHaveSafeMode;
    obj.safeModeText = safeModeText;
    obj.isPinned = _obj.IsPinned || false;
    obj = utils.cleanObjectKeys(Object.keys(new Feed()), obj);

    return obj;
  }

  static mappingObjects(_obj: FeedObject[]): Feed[] {
    return _obj.map(obj => Feed.mappingObject(obj));
  }
}
